module.exports = __webpack_public_path__ + "static/img/secure-stripe-payment-logo.8d9b26e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/secure-stripe-payment-logo.png
// module id = FXQM
// module chunks = 0